/**********************************************************
Mowing View
**********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchEmployees } from '../../actions/utils_actions';
import { fetchMowingApplications, selectMowingApplication,
  deleteMowingApplication } from '../../actions/mowing_actions';
import FabModalV2 from '../fab_modal_v2';
import MowingApplicationDisplay from './mowing_app_display';

class MowingView extends Component {
  componentDidMount() {
    if (this.props.employees.length === 0) this.props.fetchEmployees();
    this.props.fetchMowingApplications();
  }
  render() {
    return (
      <div className="row">
        <div className="chem-app-table-view">
          <table className="bordered highlight responsive-table centered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Field</th>
                <th>Employee</th>
                <th>Hours</th>
                <th>Acres Completed</th>
                <th>Acres Balance</th>
                <th>Acres / Hour</th>
                <th>Status</th>
                <th>Round</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.mowingRecords.map((m) => {
                  let { mowJobs } = m;
                  let name = 'N/A';
                  let emp = {};
                  if (this.props.employees.length > 0 && m.employee !== undefined) {
                    emp = this.props.employees.find((e) => e.eid === m.employee);
                    if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
                  }
                  return mowJobs.map((mow) => {
                    return (
                      <tr key={mow.id}>
                        <td>{ moment(m.date).format('MM/DD/YYYY') }</td>
                        <td>{ mow.field }</td>
                        <td>{ name }</td>
                        <td>{ mow.hours }</td>
                        <td>{ mow.acresCompleted }</td>
                        <td>{ mow.acresBalance }</td>
                        <td>{ mow.acresPerHour }</td>
                        <td>
                          { Number(m.isComplete) === 0 ? <span className="label label-incomplete">Incomplete</span>
                            : <span className="label label-complete">Complete</span>
                          }
                        </td>
                        <td>{ m.round }</td>
                        <td>
                          {
                            <div>
                              <ul className="btn-actions">
                                {
                                  FabModalV2(MowingApplicationDisplay)
                                  // eslint-disable-next-line
                                  ({
                                    id: `${m.id}-view`,
                                    auth: false,
                                    user: this.props.user,
                                    employees: this.props.employees,
                                    previousApplications: [],
                                    toDelete: false,
                                    view: true,
                                    footer: true,
                                    application: m,
                                    _select: () => this.props.selectMowingApplication(m)
                                  })
                                }
                                { Object.keys(this.props.user).length === 0 ? ''
                                  : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?

                                  FabModalV2(MowingApplicationDisplay)
                                  // eslint-disable-next-line
                                  ({
                                    id: `${m.id}-delete`,
                                    auth: true,
                                    user: this.props.user,
                                    employees: this.props.employees,
                                    previousApplications: [],
                                    toDelete: true,
                                    view: false,
                                    footer: true,
                                    application: m,
                                    _select: () => this.props.selectMowingApplication(m),
                                    onClick: () => this.props.deleteMowingApplication({ mowAppId: this.props.selectedApp.mowAppId })
                                  })
                                  : ''
                                }
                              </ul>
                            </div>
                          }
                        </td>
                      </tr>
                    )
                  })
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    employees: state.cultivation.utils.employees,
    mowingRecords: state.cultivation.mowing.mowingRecords.displaying,
    selectedApp: state.cultivation.mowing.view.app,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteMowingApplication,
    fetchEmployees,
    fetchMowingApplications,
    selectMowingApplication
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MowingView);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_view.js